import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import router from '../router';
import * as Sentry from '@sentry/browser';

const isProduction = process.env.NODE_ENV === 'production';
const APP_ID = 'xq49oldj';

const PLAN = {
  0: 'WHITE',
  1: 'GREY',
  2: 'BLACK',
  3: 'LIGHT_GREY'
};

const EXERCISE_TYPES = [
  { label: '1:1 PT', value: 'PT' },
  { label: '그룹 트레이닝', value: 'GX' },
  { label: '부티크 피트니스', value: 'BQ' },
  { label: '일반 피트니스센터', value: 'HL' },
  { label: '필라테스', value: 'PL' },
  { label: '요가', value: 'YG' },
  { label: '크로스핏', value: 'CF' },
  { label: '농구', value: 'BB' },
  { label: '테니스', value: 'TN' },
  { label: '야구', value: 'ML' },
  { label: '축구', value: 'FB' },
  { label: '스피닝', value: 'SP' },
  { label: '발레', value: 'BL' },
  { label: '복싱', value: 'BX' },
  { label: '댄스', value: 'DN' },
  { label: '골프', value: 'GF' },
  { label: '기타', value: 'XY' }
];

function getTimestamp(datetime) {
  return Math.floor(new Date(datetime).getTime() / 1000);
}

export function initVueAnalytics() {
  Vue.use(VueAnalytics, {
    id: 'UA-134935735-1',
    disableScriptLoader: true,
    router,
    debug: {
      sendHitTask: isProduction
    }
  });
}

export function initSentry() {
  if (isProduction) {
    Sentry.init({
      dsn: 'https://49322253b7c84f0092880215f451d3a6@sentry.io/1355532',
      integrations: [new Sentry.Integrations.Vue({ Vue })]
    });
  }
}

export function bootFullStory(centerAccount) {
  window.FS.identify(centerAccount.user.email, {
    displayName: centerAccount.name
  });
}

export function initIntercom() {
  (function() {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function() {
        i.c(arguments);
      };
      i.q = [];
      i.c = function(args) {
        i.q.push(args);
      };
      w.Intercom = i;
      var l = function() {
        var s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.src = 'https://widget.intercom.io/widget/' + APP_ID;
        var x = d.getElementsByTagName('script')[0];
        x.parentNode.insertBefore(s, x);
      };
      if (document.readyState === 'complete') {
        l();
      } else if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  })();
}

export function bootIntercom(centerAccount) {
  let intercomUserSyncData = {
    app_id: APP_ID,
    custom_launcher_selector: '#fiflbox-intercom-float-button',
    alignment: 'left'
  };
  if (centerAccount && Object.values(centerAccount).length && EXERCISE_TYPES) {
    let industry = EXERCISE_TYPES.find(
      exercise => centerAccount.code.indexOf(exercise.value) > -1
    );
    if (industry) {
      industry = industry.label;
      intercomUserSyncData = {
        ...intercomUserSyncData,
        email: centerAccount.user.email,
        name: centerAccount.user.name,
        phone: centerAccount.user.phone_number,
        company: {
          company_id: centerAccount.id,
          'Admin Page Link': `https://api.fiflapp.com/fiflbox/admin/center/center/${
            centerAccount.id
          }/change/`,
          name: centerAccount.name,
          plan: PLAN[centerAccount.plan],
          'Present Plan': PLAN[centerAccount.plan],
          industry,
          'Plan Expire Date': getTimestamp(centerAccount.expiration_date)
        },
        avatar: {
          type: 'avatar',
          image_url: centerAccount.logo
        }
      };
    }
  }

  window.Intercom('boot', intercomUserSyncData);
}

export function shutdownIntercom() {
  window.Intercom('shutdown');
}

export function showIntercom() {
  document
    .querySelector('.intercom-namespace .intercom-app')
    .classList.remove('hide');
}

export function hideIntercom() {
  document
    .querySelector('.intercom-namespace .intercom-app')
    .classList.add('hide');
}

export function initAllThirdPartyApps() {
  initVueAnalytics();
  initSentry();
  initIntercom();
}
